import { render } from "./WidgetField.vue?vue&type=template&id=71655aa9"
import script from "./WidgetField.vue?vue&type=script&lang=js"
export * from "./WidgetField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__